import React from 'react'
import PropTypes from 'prop-types'

const Title = ({ children, secondary }) =>
  <h1
    className={`${secondary
      ? 'secondary-color'
      : 'white'} primary-font-bold f2 f1-ns mt0`}
  >
    {children}
  </h1>

Title.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  secondary: PropTypes.bool
}

export default Title



// WEBPACK FOOTER //
// ./src/components/Title/Title.js